import React from "react";
export default function DefaultTemplate({ block }) {
  const {
    title,
    titleTag = "h2",
    subtitle,
    text,
    backgroundUrl,
    elementClass = "",
    contentsClassName = "",
  } = block;
  const AllowedTags = ["h1", "h2", "h3", "h4", "h5", "h6"];
  const TitleTag = AllowedTags.includes(titleTag) ? titleTag : "h2";
  return (
    <div className={[
      "block-default",
      "position-relative",
      elementClass,
    ].join(" ").trim()}>
      <div
      >
        <div className={contentsClassName}>
          {backgroundUrl && (
            <div className="background">
              <img src={backgroundUrl} alt="" />
              <div className="overlay"></div>
            </div>
          )}
          <div className="position-relative">
            {title && (
              <div className="cms-block-title">
                <TitleTag>
                  <span>{title}</span>
                </TitleTag>
              </div>
            )}
            {subtitle && (
              <div
                className="cms-block-subtitle"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            )}
          </div>
        </div>
      </div>
      {text && (
        <div
          className="cms-block-text container"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
}
